import RoutesWrapper from "./routes";

function App() {
  // console.log("Current API URL:", process.env.REACT_APP_BASE_URL);
  return <RoutesWrapper />;
}

export default App;
